<template>
  <div class="md-group info-icon">
    &nbsp;<span @click="notify()"><md-icon>info</md-icon></span>
  </div>
</template>

<script>
export default {
  name: "info-icon",
  props: ['message'],
  methods: {
    notify() {
      this.$notify(
        {
          message: this.message,
          icon: 'add_alert',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'default',
        })
    },
  }
}
</script>

<style scoped>
  .info-icon{
    margin-top: 6px;
    cursor: pointer;
  }
</style>
